import type { ColumnDef } from '@tanstack/react-table';
import type { GetMessagesResult } from '~/generated/wildduck-client/types.gen';
import TimeAgo from '~/components/time/TimeAgo';

type EmailWithStringId = Omit<GetMessagesResult, 'id'> & { id: string };

export const emailColumns: ColumnDef<EmailWithStringId>[] = [
  {
    id: 'from',
    accessorKey: 'from',
    header: 'From',
    enableSorting: false,
    maxSize: 80,
    cell: ({ row }) => {
      return (
        <span className="break-all">
          {row.original.from?.name} &lt;{row.original.from?.address}&gt;
        </span>
      );
    },
  },
  {
    id: 'to',
    accessorKey: 'to',
    header: 'To',
    enableSorting: false,
    maxSize: 150,
    cell: ({ row }) => {
      return (
        <span className="break-all">
          {row.original.to.at(0)?.name} &lt;{row.original.to.at(0)?.address}&gt;
        </span>
      );
    },
  },
  {
    id: 'subject',
    accessorKey: 'subject',
    header: 'Subject',
    enableSorting: false,
    maxSize: 200,
    cell: ({ row }) => {
      return <>{row.original.subject}</>;
    },
  },
  {
    id: 'date',
    accessorKey: 'date',
    header: 'Date',
    enableSorting: false,
    maxSize: 70,
    cell: ({ row }) => {
      return (
        <TimeAgo
          textStyle="pointer-events-auto relative z-10"
          time={new Date(row.original.date)}
          inverse
        />
      );
    },
  },
];
